export default {
  "meta.title": "Guide du Spreadsheet USFans : trouver des produits et acheter mieux",
  "meta.description":
    "Apprenez à utiliser le Spreadsheet USFans : parcourez les produits par catégorie, comparez les trouvailles, comprenez le QC, la livraison et les conseils d'achat, et achetez en toute confiance.",

  "breadcrumb.home": "Accueil",
  "breadcrumb.current": "Guide du Spreadsheet",

  "title": "Guide du Spreadsheet USFans : trouver des produits, comparer et acheter plus intelligemment",
  "lead":
    "Le Spreadsheet USFans est l'un des moyens les plus utiles de découvrir et comparer des produits dans de nombreuses catégories. Ce guide original explique son fonctionnement, la navigation dans les catégories et ce qu'il faut vérifier avant d'acheter — pour des décisions mieux informées.",

  "toc.title": "Table des matières",

  "s1.title": "Qu'est-ce que le Spreadsheet USFans ?",
  "s1.p1":
    "Le Spreadsheet USFans est un catalogue de produits partagé et organisé. Au lieu d'une page de liens aléatoires, il regroupe les articles en catégories claires telles que Chaussures, Hoodies, T-Shirts, Vestes, Pantalons, Couvre-chefs, Sacs et Accessoires. Cette structure facilite grandement la recherche d'un type de produit précis et la comparaison de ce qui est disponible.",
  "s1.p2":
    "Beaucoup utilisent ce spreadsheet comme point de départ pour leurs recherches produit. Il permet de voir d'un coup d'œil les catégories existantes, les types de produits listés et où aller ensuite pour en savoir plus.",

  "s2.title": "Utiliser le Spreadsheet étape par étape",
  "s2.p1":
    "L'utilisation du spreadsheet est simple, même pour les débutants. Suivez ces étapes pour en tirer le meilleur parti.",
  "s2.li1": "Choisissez une catégorie qui vous intéresse, comme Chaussures ou Sacs.",
  "s2.li2": "Consultez les produits listés dans cette catégorie.",
  "s2.li3": "Comparez les informations disponibles, y compris les photos et descriptions.",
  "s2.li4": "Vérifiez les notes QC et les détails de livraison avant de décider.",
  "s2.li5": "Suivez le lien vers le site principal pour voir les détails et commander.",
  "s2.p2":
    "Grâce à l'organisation par catégorie, vous gagnez du temps par rapport à une liste non structurée. Vous accédez directement à la section qui vous intéresse.",

  "s3.title": "Parcourir les principales catégories de produits",
  "s3.p1":
    "Le spreadsheet couvre une large gamme de types de produits. Voici les principales catégories que vous trouverez généralement, avec une brève description.",
  "s3.shoes": "Chaussures — baskets, chaussures casual et sport.",
  "s3.hoodies": "Hoodies/Sweats — pulls et zippés.",
  "s3.tshirts": "T-Shirts — hauts à manches courtes et longues.",
  "s3.jackets": "Vestes — vêtements d'extérieur pour toutes saisons.",
  "s3.pants": "Pantalons/Shorts — jeans, chinos et shorts.",
  "s3.headwear": "Couvre-chefs — casquettes, chapeaux et bonnets.",
  "s3.sets": "Ensembles — tenues coordonnées assorties.",
  "s3.underwear": "Sous-vêtements/Caleçons — sous-vêtements et caleçons.",
  "s3.jersey": "Maillots — maillots de sport et d'équipe.",
  "s3.accessories": "Accessoires — petits ajouts et extras.",
  "s3.bags": "Sacs — sacs à dos, sacs à main et fourre-tout.",
  "s3.belts": "Ceintures — ceintures en cuir et casual.",
  "s3.perfumes": "Parfums — fragrances pour hommes et femmes.",
  "s3.other": "Autres articles — divers et nouveautés.",
  "s3.p2":
    "Vous pouvez explorer chaque catégorie depuis la page d'accueil via le menu déroulant ou les cartes de catégories. Chacune ouvre la section correspondante sur le site principal.",

  "s4.title": "Ce qu'il faut vérifier avant d'acheter",
  "s4.p1":
    "Une bonne décision d'achat commence par une vérification rapide des informations produit. Voici les points clés à contrôler sur chaque annonce.",
  "s4.li1": "Photos produit — assurez-vous qu'elles montrent clairement l'article.",
  "s4.li2": "Description — lisez les détails sur la matière, la taille et la couleur.",
  "s4.li3": "Informations QC — cherchez les photos de contrôle qualité si disponibles.",
  "s4.li4": "Conditions de livraison — comprenez le coût et le délai estimé.",
  "s4.li5": "Méthodes de paiement — confirmez les options disponibles.",
  "s4.p2":
    "Prendre quelques secondes pour vérifier ces détails vous évite des surprises et vous aide à choisir des produits conformes à vos attentes.",

  "s5.title": "Notes sur la livraison et l'expédition",
  "s5.p1":
    "Les frais et délais de livraison peuvent varier selon votre localisation et le produit. En général, les articles plus lourds ou volumineux peuvent coûter plus cher, et les commandes internationales prennent plus de temps.",
  "s5.p2":
    "Consultez toujours les informations de livraison affichées sur le site principal avant de passer commande. Si une annonce inclut une estimation, utilisez-la comme guide et non comme garantie.",

  "table.caption": "Comparaison rapide : ce qu'il faut vérifier sur chaque produit",
  "table.head1": "Facteur",
  "table.head2": "Ce qu'il faut vérifier",
  "table.head3": "Pourquoi c'est important",
  "table.r1c1": "Produit",
  "table.r1c2": "Photos et description",
  "table.r1c3": "Aide à la recherche",
  "table.r2c1": "QC",
  "table.r2c2": "Infos de contrôle qualité",
  "table.r2c3": "Montre la qualité",
  "table.r3c1": "Livraison",
  "table.r3c2": "Méthodes actuelles",
  "table.r3c3": "Aide à planifier",
  "table.r4c1": "Paiement",
  "table.r4c2": "Conditions de paiement",
  "table.r4c3": "Sécurise la commande",

  "faq.title": "Questions fréquentes",
  "faq.q1": "Le Spreadsheet USFans est-il gratuit à parcourir ?",
  "faq.a1":
    "Oui, parcourir les catégories et les informations produit via cette ressource est gratuit. Vous ne payez que si vous choisissez d'acheter sur le site principal.",
  "faq.q2": "Puis-je acheter directement sur ce site ?",
  "faq.a2":
    "Non. Ce site est une ressource d'information qui vous redirige vers le site principal USFans, où les achats sont finalisés.",
  "faq.q3": "À quelle fréquence le spreadsheet est-il mis à jour ?",
  "faq.a3":
    "Le spreadsheet est régulièrement entretenu et mis à jour. Pour les annonces les plus récentes, consultez toujours le site principal.",
  "faq.q4": "Comment trouver une catégorie précise ?",
  "faq.a4":
    "Utilisez le menu déroulant ou les cartes de catégories sur la page d'accueil pour accéder directement à la section souhaitée.",

  "cta.title": "Commencez à parcourir le Spreadsheet USFans",
  "cta.text":
    "Maintenant que vous comprenez son fonctionnement, explorez les catégories et comparez les trouvailles avant d'acheter.",
  "cta.back": "Retour à l'accueil",

  "safety.title": "Note de sécurité",
  "safety.text":
    "Ce guide fournit uniquement des informations. Vérifiez toujours les détails du produit et les conditions de livraison sur le site principal avant tout achat.",
};